import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CssVariableSnippetComponent } from '../../../../shared/components/css-variable-snippet/css-variable-snippet.component';
import { StylingCardShellComponent } from '../styling-card-shell/styling-card-shell.component';

@Component({
    selector: 'avd-outline-color-card',
    standalone: true,
    templateUrl: './outline-color-card.component.html',
    styleUrls: ['./outline-color-card.component.scss'],
    imports: [StylingCardShellComponent, CssVariableSnippetComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OutlineColorCardComponent {
    @Input() cssVariable: string = '';
    @Input() label: string = '';
    @Input() inverseMode: boolean = false;

    get cssVariableName(): string {
        return this.cssVariable.trim();
    }

    get borderColor(): string {
        if (!this.cssVariableName) {
            return 'transparent';
        }

        return `var(${this.cssVariableName})`;
    }

    get cssVariableSnippet(): string {
        return this.cssVariableName;
    }
}
